import { gql } from 'react-apollo';
import {
    SET_THREAD_ARCHIVE_START,
    SET_THREAD_ARCHIVE_SUCCESS,
    SET_THREAD_ARCHIVE_ERROR
} from '../constants';
import showToaster from '../helpers/showToaster';

export function archiveThread(id, isArchive) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: SET_THREAD_ARCHIVE_START
        });
        
        try {
            let mutation = gql`
            mutation archiveThread ($id: Int!, $isArchive: Int!){
                archiveThread(id: $id, isArchive: $isArchive){
                    status
                    errorMessage
                }
              }
            `;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    isArchive
                }
            });


            if (data && data.archiveThread && data.archiveThread.status == '200') {
                dispatch({
                    type: SET_THREAD_ARCHIVE_SUCCESS
                });
                showToaster({ messageId: isArchive ? 'moveArchiveSuccess' : 'moveunArchiveSuccess', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: SET_THREAD_ARCHIVE_ERROR
                });
                showToaster({ messageId: isArchive ? 'moveArchiveError' : 'moveunArchiveError', toasterType: 'error' })
            }
        } catch (error) {
            dispatch({
                type: SET_THREAD_ARCHIVE_ERROR
            });
            showToaster({ messageId: isArchive ? 'moveArchiveError' : 'moveunArchiveError', toasterType: 'error' })
        }
    }
}